module.exports = __webpack_public_path__ + "static/media/avatar.0fe70b9e.png";